// extracted by mini-css-extract-plugin
module.exports = {"RegisteredCard":"RegisteredCard_RegisteredCard__VFpmQ"};